import { createTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';

const theme = createTheme({
  palette: {
    primary: blue,
  },
  clears: {
    margin: 0,
  },
  body: {
    margin: 0,
  },
  header: {
    background: '#abc',
  },
  footer: {
    background: '#abc',
  }
});

export default theme
